// extracted by mini-css-extract-plugin
export default {"wrapper":"AcknowledgeAlarm_wrapper__ayQAn"};